import {
  organisationKeys,
  RequestTypes,
} from '@core/react-query/features/organisations/organisation'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import { usePageableQuery } from '@core/react-query/hooks'
import {
  IOrganisationsListItem,
  OrganisationsListItem,
} from '@core/entities/organisation'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = (response: PageResponse<IOrganisationsListItem>) => ({
  ...response,
  content: response.content.map((user) => OrganisationsListItem.new(user)),
})

export const useGetOrganisations = (
  payload: RequestTypes['getOrganisations'],
  options: UseInfiniteQueryOptions<
    PageResponse<IOrganisationsListItem>,
    RequestErrorType,
    PageResponse<OrganisationsListItem>
  > = {},
) => {
  const orgUsersQuery = organisationKeys.list(payload)

  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options.enabled,
    queryKey: orgUsersQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<IOrganisationsListItem>,
    RequestErrorType,
    PageResponse<OrganisationsListItem>
  >({
    ...infiniteQueryOptions,
    ...orgUsersQuery,
    ...options,
  })
}
